export default function HowDoWeShop({ children }) {
  return (
    <>
      <p>
        Go on a Friday Shopping! spree with SHOP. Visit the exhibition happening at Bugis+ Level 1
        (walkway) where the works and exhibits on display will be introduced by Melvin Ho, a
        talented “roadshow” emcee specially engaged for this night. Hearing Melvin’s “radio-like”
        voice echo throughout the mall while walking around is part of the shopping experience!
      </p>
      {children}
    </>
  );
}
